export const getSearchData = (searchParams, pageNumber) => {
    const data = {
        query: searchParams.searchPhrase,
        rows: searchParams.itemsPerPage,
        start: (pageNumber - 1) * searchParams.itemsPerPage,
        tab: searchParams.tab,
        aggs: searchParams.aggs,
        filters: searchParams.filters,
        sort: searchParams.sort
      };
      
    return data
}

export const getExportData = (searchParams, pageNumber, format) => {
    const data = {
        query: searchParams.searchPhrase,
        rows: searchParams.itemsPerPage,
        start: (pageNumber - 1) * searchParams.itemsPerPage,
        tab: searchParams.tab,
        aggs: searchParams.aggs,
        filters: searchParams.filters,
        sort: searchParams.sort,
        format: format
      };

    return data
}

export const getHighlightData = (highLightedId) => {
    let data = {
        id: highLightedId
    }

    return data
}

export const getAggregations = (aggsArray, metadataObjects, aggFieldForTab) => {
    let aggs = {
    };

    // Iterate over metadataObjects and check if the hash matches any value in aggsArray
    metadataObjects.forEach(obj => {
        if (aggsArray.includes(obj.hash)) {
            obj.aggregatedFields.forEach(field => {
                if (field.datatype === 'datetime' && field.aggregation) {
                    aggs[field.id] = {
                        date_histogram: {
                            field: field.id,
                            calendar_interval: field.aggregation.interval,
                            format: field.aggregation.format,
                            min_doc_count: field.aggregation.min_doc_count
                        }
                    };
                } else {
                    aggs[field.id] = {
                        terms: {
                            field: field.id
                        }
                    }
                }
            });
        }
    });

    // Add tab field to aggregation
    aggs['fieldForTab'] = {
        terms: { field: aggFieldForTab}
    }

    return aggs
}

export const getFilters = (filter) => {
    let filters = {}

    // Date Filter
    if (filter.startDate && filter.endDate) {
        filters.creationDate = {
                from: queryFormatDate(filter.startDate),
                to: queryFormatDate(filter.endDate)
            }
    } else if (filter.startDate) {
        filters.creationDate = {
                from: queryFormatDate(filter.startDate),
                to: '*'
            }
    } else if (filter.endDate) {
        filters.creationDate = {
                from: '*',
                to: queryFormatDate(filter.endDate)
            }
    }

    // Document Source Filter
    if (filter.source !== 'all') {
        filters.sourceId = filter.source
    }
    
    return filters
}

export const getSort = (filter) => {
    let sort = {}

    // Order By Sort
    if (filter.sort !== 'default') {
        if (filter.sort === 'dateAsc') {
            sort = {creationDate: 'asc'};
        } else if (filter.sort === 'dateDesc') {
            sort = {creationDate: 'desc'};
        } else if (filter.sort === 'createdByAsc') {
            sort = {createdBy: 'asc'};
        } else if (filter.sort === 'createdByDesc') {
            sort = {createdBy: 'desc'};
        }
    }

    return sort
}

export const queryFormatDate = (dateString) => {
    // Parse the input date string
    const date = new Date(dateString);

    // Format the date to the required format (YYYY-MM-DDThh:mm:ssZ)
    const formattedDate = date.toISOString();

    return formattedDate;
}
  
export default { getSearchData, getExportData, getHighlightData, getAggregations, getFilters, getSort }